'use client';

import { useMemo } from 'react';
import { useRouter } from 'next/router';
import {
  useCreateMarketFilters,
  useCreateProductFilters,
} from '@/creditflowresearch/application/PageFilters/hooks/create';
import { HycProduct, IgcProduct, Product } from '@/creditflowresearch/domain/Product';
import { EuropeanMarket, UsMarket } from '@/creditflowresearch/domain/Market';
import type { IFilterSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';
import { transformToFilterSets } from './helpers/transformToFilterSets';

export const useCorporateStatsFilters = (): IFilterSet[] => {
  const { query } = useRouter();
  const allProducts = useCreateProductFilters();
  const allMarkets = useCreateMarketFilters();

  const products = useMemo(
    () => allProducts.filter(({ id }) =>
      Product.isOfType(id, HycProduct.TYPE) || Product.isOfType(id, IgcProduct.TYPE),
    ),
    [allProducts],
  );

  const markets = useMemo(
    () => allMarkets.filter(({ id }) =>
      id === UsMarket.MARKET_ID || id === EuropeanMarket.MARKET_ID,
    ),
    [allMarkets],
  );

  return transformToFilterSets([
    {
      key: 'markets',
      items: markets,
    },
    {
      key: 'products',
      items: products,
    },
  ], query);
};
